import React from 'react';
import chair from '../../../assets/images/chair.png';
import bg from '../../../assets/images/bg.png';
import { Link } from 'react-router-dom';


const Banner = () => {
    return (
        <div>
            <div className="hero ">
                <img src={bg} className=" rounded-lg w-full shadow-2xl" alt='' />
                <div className="hero-content flex-col lg:flex-row-reverse">
                    <img src={chair} className=" w-full rounded-lg lg:w-1/2 shadow-2xl" alt='' />
                    <div>

                        <h1 className=" text-2xl lg:text-5xl font-bold">Doctor Portal – Trusted Dental Care for a Brighter Smile</h1>
                        <p className=" py-6">Doctor Portal is your reliable destination for comprehensive dental care. We specialize in preventive, cosmetic, and restorative dentistry to keep your smile healthy and confident. Our expert dentists ensure a comfortable experience with personalized treatments tailored to your needs.</p>
                        <Link to={"/login"} className=" btn btn-primary bg-gradient-to-r from-primary to-secondary text-white">Get Started</Link>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Banner;